export const headerData = {
  hasSearch: true,
  hasPaging: true,
  hasTryMe: false,
  fields: [
    {
      fieldName: 'count',
      headerName: 'Count',
    },
    {
      fieldName: 'chatTitle',
      headerName: 'Questions',
    },
    {
      fieldName: 'createdOn',
      headerName: 'Date And Time',
      isDatetime: true,
      hasSort: true,
      isDesc: true,
    },
  ],
};
